import { MonitorBase } from './_MonitorBase';

export class MonitorVersions extends MonitorBase {
  constructor(game, parent, config) {
    super(game, parent, { label: 'versions', ...config });
    this.updateMonitor();
  }

  shutdown() {}

  updateMonitor() {
    let versionString = `Phaser: ${Phaser.VERSION}, Build: ${__VERSION__}`;
    this.setValue(versionString);
  }

  getLog() {
    let str = '';
    str += `\nPhaser Version\t\t: ${Phaser.VERSION}`;
    str += `\nBuild Version\t\t: ${__VERSION__}`;
    return str;
  }
}
